<template>
	<div class="medical_aesthetics" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="租房系统上线告知" :fixed="true" />
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
				<img src="../../assets/advDetail/realEstate/recruitment.jpg" >
			</van-col>
		</van-row>
	</div>
</template>
<script>
export default {
  data() {
    return {
    	isApp: true,
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	}
  }
};
</script>
<style lang="less">
.medical_aesthetics {
	background: #f2f2f2;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.content{
		background: #f2f2f2;
		img{
			width: 100%;
			display: block;
		}
	}
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}

</style>
